import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as actions from "../../../../../actions/intergammaOrderActions";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as formatHelper from "../../../../../helpers/formatHelper";

class LoadHistoryOrderModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseLoadHistoryOrderModalAction();
    };

    handleYesButtonClick = () => {
        if (
            this.props.activeOrder !== null &&
            this.props.printData !== null &&
            this.props.printData.orderqrcode !== undefined &&
            this.props.printData.orderqrcode !== null
        ) {
            this.props.dispatchLoadOrderAction(this.props.printData.orderqrcode);
            this.props.dispatchCloseLoadHistoryOrderModalAction();
        }
    };

    getOrderDetail = () => {
        if (this.props.activeOrder === null) {
            return null;
        }

        return (
            <table>
                <thead className="color-red">
                    <tr>
                        <th className="col-xs-4">
                            <Translate value="general.product" />
                        </th>
                        <th className="col-xs-4">
                            <Translate value="general.color" />
                        </th>
                        <th className="col-xs-4">
                            <Translate value="general.fandeck" />
                        </th>
                        <th className="col-xs-4">
                            <Translate value="general.package" />
                        </th>
                        <th className="col-xs-4">
                            <Translate value="general.date" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr key={this.props.activeOrder.id} data-id={this.props.activeOrder.id}>
                        <td>{this.props.activeOrder.product.displayName}</td>
                        <td>{this.props.activeOrder.formula.color.displayName}</td>
                        <td>{this.props.activeOrder.fandeck.displayName}</td>
                        <td>
                            {this.props.activeOrder.packageCount} x {this.props.activeOrder.package.name}
                        </td>
                        <td>
                            {this.props.activeOrder.created === null
                                ? ""
                                : formatHelper.formatDateTimeUtc(this.props.activeOrder.created.toString())}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    getLoadButton = () => {
        if (
            this.props.activeOrder === null ||
            this.props.printData === null ||
            this.props.printData.orderqrcode === undefined ||
            this.props.printData.orderqrcode === null
        ) {
            return null;
        }

        return (
            <div className="col-xs-6 text-left">
                <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleYesButtonClick}>
                    <span className="glyphicon glyphicon-menu-right" />
                    <Translate value="general.yes" />
                </button>
            </div>
        );
    };

    render() {
        return (
            <div className="default-modal ig-history-order-modal ig-small-modal">
                <div className="modal-content">
                    <div className="col-xs-12 ">
                        <Translate value="customRedlike.loadHistoryOrder" />
                        {this.getOrderDetail()}
                    </div>
                    <div className="modal-footer">
                        <div className="col-xs-6 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleCloseModalClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.no" />
                            </button>
                        </div>
                        {this.getLoadButton()}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        activeOrder: store.myOrders.activeOrder,
        printData: store.myOrders.printData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseLoadHistoryOrderModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_LOAD_HISTORY_ORDER_MODAL));
        },
        dispatchLoadOrderAction: (qrCode) => {
            dispatch(actions.loadHistoryOrder(qrCode));
        }
    };
};

export default LoadHistoryOrderModal = connect(mapStoreToProps, mapDispatchToProps)(LoadHistoryOrderModal);
